export const LANGUAGE_OPTIONS = [
  {
    code: "zh_cn",
    label: "简中",
    short: "ZH",
    fullLabel: "简体中文",
    appLang: "zh_cn",
    copyLang: "zh_cn",
  },
  {
    code: "zh_tw",
    label: "繁中",
    short: "TW",
    fullLabel: "繁體中文",
    appLang: "zh_tw",
    copyLang: "zh_tw",
  },
  {
    code: "en_us",
    label: "EN",
    short: "EN",
    fullLabel: "English",
    appLang: "en_us",
    copyLang: "en_us",
  },
];

export const DEFAULT_LANGUAGE_OPTION =
  LANGUAGE_OPTIONS.find((item) => item.code === "zh_cn") || LANGUAGE_OPTIONS[0];

const LANGUAGE_ALIASES = {
  "zh-TW": "zh_tw",
  zh_hk: "zh_tw",
  tw: "zh_tw",
};

export function findLanguageOption(code) {
  const normalizedCode = LANGUAGE_ALIASES[code] || code;
  return (
    LANGUAGE_OPTIONS.find(
      (item) => item.code === normalizedCode || item.appLang === normalizedCode
    ) || null
  );
}

export function resolveLanguageOption(savedDisplayLang, savedLang) {
  return (
    findLanguageOption(savedDisplayLang) ||
    findLanguageOption(savedLang) ||
    DEFAULT_LANGUAGE_OPTION
  );
}

/**
 * Apply language everywhere: i18n + localStorage keys used by different pages.
 * Without syncing login_display_lang, Home/Login initLanguage can silently revert.
 */
export function applyAppLanguage(vm, languageOrCode, options = {}) {
  const language =
    languageOrCode && typeof languageOrCode === "object"
      ? languageOrCode
      : findLanguageOption(languageOrCode) || DEFAULT_LANGUAGE_OPTION;

  if (vm && vm.$i18n) {
    vm.$i18n.locale = language.appLang;
  }

  localStorage.setItem("lang", language.appLang);
  localStorage.setItem("login_display_lang", language.code);
  // Legacy key used by Language.vue / some older paths
  localStorage.setItem("displayLang", language.code);

  if (typeof window !== "undefined" && options.emit !== false) {
    window.dispatchEvent(
      new CustomEvent("app-language-changed", {
        detail: { code: language.code, appLang: language.appLang },
      })
    );
  }

  return language;
}

export function readSavedLanguageOption() {
  return resolveLanguageOption(
    localStorage.getItem("login_display_lang") || localStorage.getItem("displayLang"),
    localStorage.getItem("lang")
  );
}
